export default "__VITE_ASSET__DWOD$B06__"